import R from 'ramda'
import React from 'react'
import { shouldUpdate } from 'recompose'
import moment from 'moment'

export const composeCompare = (compare1, compare2) => (a, b) => {
  const first = compare1(a, b)
  if (first === 0) return compare2(a, b)
  return first
}
export const safeStr = str => '' || str
export const safeState = str => {
  switch (str) {
    case 'HOT':
      return 0
    case 'WARM':
      return 1
    case 'COLD':
      return 2
    case 'GEN':
      return 3
  }
  return 4
}

export const safeCompare = (guard, compare) => (a, b) =>
  compare(guard(a), guard(b))

export const strCompare = (a, b) => a.localeCompare(b)

export const numCompare = (a, b) => a - b

export const safeStrCompare = (safeStr, strCompare)

export const compareState = safeCompare(safeState, numCompare)

export const safeMw = mwValue => mwValue || -1

export const compareSegId = safeCompare(
  ({ mwSegId }) => safeMw(mwSegId),
  numCompare
)

export const compareUnitIdByUnitMap = unitMap =>
  safeCompare(id => safeStr(unitMap[id]), strCompare)

export const sortUnitIds = unitMap => R.sort(compareUnitIdByUnitMap(unitMap))

export const connectSelectorsToStateTree = getRootState =>
  R.compose(
    R.fromPairs,
    R.map(([name, selector]) => [name, R.compose(selector, getRootState)]),
    R.toPairs
  )

export const pureDebugger = shouldUpdate((props, nextProps) => {
  const vals = R.uniq(R.keys(props).concat(R.keys(nextProps)))
    .map(k => ({ key: k, current: props[k], next: nextProps[k] }))
    .map(({ key, current, next }) => ({
      key,
      current,
      next,
      eq: current === next,
    }))

  vals
    .filter(({ eq }) => !eq)
    .forEach(
      /* eslint-disable no-console */
      ({ key, current, next }) =>
        console.log(
          /* eslint-enable no-console */
          key,
          ' is not equal',
          'current: ',
          current,
          'next: ',
          next
        )
    )
  return true
})

const momentOf = ({ year, month }) =>
  moment()
    .year(year)
    .month(month - 1)
    .date(1)
    .hour(0)
    .minute(0)
    .second(0)
    .millisecond(0)

export const toStartEnd = ({ from, to }) => ({
  start: momentOf(from),
  end: momentOf(to)
    .add(1, 'month')
    .add(-1, 'day'),
})
